import { useQuery } from '@tanstack/react-query';

import { listClaimRecords } from '~/services/ClaimCampaignService';

import type { ListClaimRecordsParams } from '~/types/claimCampaignTypes';

import { claimCampaignQueryKeys } from './claimCampaignQueryKeys';

interface UseListClaimRecordsOptions {
  enabled?: boolean;
}

/**
 * Fetches claim records for a campaign with optional status filter and pagination.
 */
export function useListClaimRecords(
  campaignId: string,
  params: ListClaimRecordsParams,
  options: UseListClaimRecordsOptions = {},
) {
  const { enabled = true } = options;

  return useQuery({
    queryKey: claimCampaignQueryKeys.claimsList(campaignId, params),
    queryFn: async ({ signal }) => {
      return await listClaimRecords(campaignId, params, { signal });
    },
    placeholderData: (previousData) => previousData,
    enabled: enabled && !!campaignId,
    retry: false,
  });
}
